import { motion } from "framer-motion";
const Career = () => {
  return (
    <>
        {/* Sub Header */}
       <div className="absolute left-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Bottom Pink Blobs */}
        <div className="absolute left-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Top Green Blobs */}
        <div className="absolute left-[50%] top-[5%] transform -translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[50%] top-[5%] transform translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
          <div className="mt-20">
      

      {/* Button */}
      <motion.div
        className="flex justify-center items-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1 }}
      >
        <motion.button
          className="relative bg-[#432DD7] w-[178px] h-[60px] text-white font-[Nunito] rounded-full text-center flex justify-center items-center"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          Join Our Team
        </motion.button>
      </motion.div>

      {/* Headings */}
      <motion.h2
        className="md:text-[64px] text-[40px] font-[Nunito] font-[700] text-center"
        style={{ fontFamily: "PT Sans" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        Build Your Career With Us
      </motion.h2>
<br />
      <motion.h2
        className="text-[#432DD7] relative font-[Allison] text-center md:text-[64px] text-[40px] font-[400] relative"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        and unlock endless growth opportunities today.
      </motion.h2>

      {/* Description */}
      <motion.div
        className="items-center justify-center flex"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1, delay: 0.7 }}
      >
        <h2 className="font-[Nunito] relative text-center text-[20px] md:w-[1048px]">
        At Godhani Technology, we're always looking for talented individuals to join our team. Explore our current openings and find your perfect role.
        </h2>
      </motion.div>
    </div>
<br /><br />

    </>
  )
}

export default Career
